module.exports = __webpack_public_path__ + "img/icon-otp.b3fb5599.svg";